import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import AdBanner from '../components/Layout/AdBanner';

const Blog: React.FC = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'What is an invoice and what is it for?',
      slug: 'what-is-invoice',
      excerpt: 'Learn the basics of invoicing and why every business needs proper invoice management.',
      publishedAt: '2024-07-10',
      readTime: 5,
      category: 'Basics',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 2,
      title: 'How to issue invoices as a freelancer',
      slug: 'invoices-for-self-employed',
      excerpt: 'A complete guide for freelancers on creating and managing invoices professionally.',
      publishedAt: '2024-07-08',
      readTime: 8,
      category: 'Freelancing',
      image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 3,
      title: 'Difference between invoice and tax receipt',
      slug: 'invoice-vs-invoice',
      excerpt: 'Understanding the key differences between invoices and tax receipts for your business.',
      publishedAt: '2024-07-05',
      readTime: 6,
      category: 'Basics',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 4,
      title: 'Custom invoice templates for your business',
      slug: 'invoice-templates',
      excerpt: 'Discover how to create custom invoice templates that reflect your brand identity.',
      publishedAt: '2024-07-03',
      readTime: 7,
      category: 'Templates',
      image: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 5,
      title: 'How to declare income with invoices',
      slug: 'declare-invoice-taxes',
      excerpt: 'Learn how to properly declare your invoice income for tax purposes.',
      publishedAt: '2024-07-01',
      readTime: 10,
      category: 'Taxes',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 6,
      title: 'Best practices when creating an invoice',
      slug: 'good-practices-invoice',
      excerpt: 'Essential best practices to create professional and effective invoices.',
      publishedAt: '2024-06-29',
      readTime: 9,
      category: 'Best Practices',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 7,
      title: 'How to handle international invoices',
      slug: 'international-invoicing',
      excerpt: 'Tips and strategies for handling invoices with international clients and currencies.',
      publishedAt: '2024-06-27',
      readTime: 7,
      category: 'International',
      image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 8,
      title: 'Digital invoicing: Benefits and implementation',
      slug: 'digital-invoicing',
      excerpt: 'How to transition from paper to digital invoices and the benefits for your business.',
      publishedAt: '2024-06-25',
      readTime: 6,
      category: 'Digital',
      image: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 9,
      title: 'Invoice payment terms explained',
      slug: 'payment-terms',
      excerpt: 'Understanding different payment terms and how to choose the right ones for your business.',
      publishedAt: '2024-06-23',
      readTime: 8,
      category: 'Basics',
      image: 'https://images.unsplash.com/photo-1579621970590-9d624316904b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 10,
      title: 'How to handle late payments professionally',
      slug: 'late-payments',
      excerpt: 'Strategies for dealing with late payments while maintaining good client relationships.',
      publishedAt: '2024-06-21',
      readTime: 9,
      category: 'Best Practices',
      image: 'https://images.unsplash.com/photo-1518458028785-8fbcd101ebb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 11,
      title: 'Invoice automation tools for small businesses',
      slug: 'invoice-automation',
      excerpt: 'Review of the best invoice automation tools to streamline your billing process.',
      publishedAt: '2024-06-19',
      readTime: 7,
      category: 'Tools',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 12,
      title: 'Creating a professional invoice numbering system',
      slug: 'invoice-numbering',
      excerpt: 'How to create an effective invoice numbering system for better organization.',
      publishedAt: '2024-06-17',
      readTime: 5,
      category: 'Organization',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 13,
      title: 'Tax deductions for freelancers',
      slug: 'freelancer-tax-deductions',
      excerpt: 'Common tax deductions that freelancers should know about to save money.',
      publishedAt: '2024-06-15',
      readTime: 10,
      category: 'Taxes',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 14,
      title: 'How to create recurring invoices',
      slug: 'recurring-invoices',
      excerpt: 'Setting up and managing recurring invoices for subscription-based services.',
      publishedAt: '2024-06-13',
      readTime: 6,
      category: 'Automation',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 15,
      title: 'Invoice design principles for better branding',
      slug: 'invoice-design',
      excerpt: 'Design tips to make your invoices stand out and reinforce your brand identity.',
      publishedAt: '2024-06-11',
      readTime: 7,
      category: 'Design',
      image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 16,
      title: 'Legal requirements for invoices in different countries',
      slug: 'invoice-legal-requirements',
      excerpt: 'Understanding the varying legal requirements for invoices across different countries.',
      publishedAt: '2024-06-09',
      readTime: 11,
      category: 'Legal',
      image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 17,
      title: 'How to invoice for project-based work',
      slug: 'project-invoicing',
      excerpt: 'Best practices for invoicing clients when working on project-based contracts.',
      publishedAt: '2024-06-07',
      readTime: 8,
      category: 'Freelancing',
      image: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 18,
      title: 'Invoice financing options for small businesses',
      slug: 'invoice-financing',
      excerpt: 'Exploring different invoice financing options to improve cash flow.',
      publishedAt: '2024-06-05',
      readTime: 9,
      category: 'Finance',
      image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 19,
      title: 'How to create professional estimates and quotes',
      slug: 'estimates-quotes',
      excerpt: 'Guide to creating estimates and quotes that convert into paid invoices.',
      publishedAt: '2024-06-03',
      readTime: 7,
      category: 'Sales',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 20,
      title: 'Invoice security: Protecting against fraud',
      slug: 'invoice-security',
      excerpt: 'How to protect your business from invoice fraud and security threats.',
      publishedAt: '2024-06-01',
      readTime: 8,
      category: 'Security',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 21,
      title: 'Creating invoices for digital products and services',
      slug: 'digital-product-invoices',
      excerpt: 'Special considerations when invoicing for digital products and services.',
      publishedAt: '2024-05-30',
      readTime: 6,
      category: 'Digital',
      image: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 22,
      title: 'How to handle invoice disputes',
      slug: 'invoice-disputes',
      excerpt: 'Strategies for resolving invoice disputes and disagreements with clients.',
      publishedAt: '2024-05-28',
      readTime: 9,
      category: 'Client Relations',
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 23,
      title: 'Invoice templates for different industries',
      slug: 'industry-templates',
      excerpt: 'Specialized invoice templates for various industries and business types.',
      publishedAt: '2024-05-26',
      readTime: 7,
      category: 'Templates',
      image: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 24,
      title: 'Invoicing for time-based services',
      slug: 'time-based-invoicing',
      excerpt: 'Best practices for tracking and invoicing hourly or time-based work.',
      publishedAt: '2024-05-24',
      readTime: 8,
      category: 'Freelancing',
      image: 'https://images.unsplash.com/photo-1508873535684-277a3cbcc4e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 25,
      title: 'VAT and sales tax on invoices explained',
      slug: 'vat-sales-tax',
      excerpt: 'Understanding how to correctly apply VAT and sales tax on your invoices.',
      publishedAt: '2024-05-22',
      readTime: 10,
      category: 'Taxes',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 26,
      title: 'Invoice tracking systems for better organization',
      slug: 'invoice-tracking',
      excerpt: 'Tools and methods to track invoices and maintain organized financial records.',
      publishedAt: '2024-05-20',
      readTime: 7,
      category: 'Organization',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 27,
      title: 'How to create invoices in multiple currencies',
      slug: 'multi-currency-invoices',
      excerpt: 'Guide to creating and managing invoices in different currencies.',
      publishedAt: '2024-05-18',
      readTime: 8,
      category: 'International',
      image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 28,
      title: 'Invoice payment gateways comparison',
      slug: 'payment-gateways',
      excerpt: 'Comparing different payment gateways to accept invoice payments online.',
      publishedAt: '2024-05-16',
      readTime: 9,
      category: 'Payments',
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 29,
      title: 'Creating accessible invoices for all clients',
      slug: 'accessible-invoices',
      excerpt: 'How to make your invoices accessible to clients with different needs.',
      publishedAt: '2024-05-14',
      readTime: 6,
      category: 'Accessibility',
      image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 30,
      title: 'Invoice archiving and record keeping',
      slug: 'invoice-archiving',
      excerpt: 'Best practices for archiving invoices and maintaining financial records.',
      publishedAt: '2024-05-12',
      readTime: 7,
      category: 'Organization',
      image: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 31,
      title: 'How to create professional credit notes',
      slug: 'credit-notes',
      excerpt: 'Guide to creating and issuing credit notes for invoice adjustments.',
      publishedAt: '2024-05-10',
      readTime: 6,
      category: 'Basics',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 32,
      title: 'Invoice analytics for business insights',
      slug: 'invoice-analytics',
      excerpt: 'How to use invoice data to gain valuable insights for your business.',
      publishedAt: '2024-05-08',
      readTime: 8,
      category: 'Analytics',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 33,
      title: 'Mobile invoicing apps for on-the-go businesses',
      slug: 'mobile-invoicing',
      excerpt: 'Review of the best mobile apps for creating and sending invoices from anywhere.',
      publishedAt: '2024-05-06',
      readTime: 7,
      category: 'Tools',
      image: 'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 34,
      title: 'Seasonal invoicing strategies for businesses',
      slug: 'seasonal-invoicing',
      excerpt: 'How to adapt your invoicing strategy for seasonal business fluctuations.',
      publishedAt: '2024-05-04',
      readTime: 9,
      category: 'Strategy',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 35,
      title: 'Building client trust through transparent invoicing',
      slug: 'transparent-invoicing',
      excerpt: 'How transparent invoicing practices can build stronger client relationships.',
      publishedAt: '2024-05-02',
      readTime: 8,
      category: 'Client Relations',
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  const categories = [
    'All', 'Basics', 'Freelancing', 'Templates', 'Taxes', 'Best Practices', 
    'International', 'Digital', 'Organization', 'Tools', 'Finance', 'Legal',
    'Security', 'Client Relations', 'Payments', 'Analytics', 'Strategy'
  ];
  
  const [selectedCategory, setSelectedCategory] = React.useState('All');
  const [currentPage, setCurrentPage] = React.useState(1);
  const postsPerPage = 9;

  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  // Pagination
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="pt-12 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Invoice & Business Blog
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Learn everything about invoicing, freelancing, and running a successful business with our comprehensive guides and tutorials.
            </p>
          </div>

          {/* Ad Banner */}
          <div className="mb-12">
            <AdBanner size="responsive" className="mx-auto" />
          </div>

          {/* Categories Filter */}
          <div className="mb-8 overflow-x-auto">
            <div className="flex flex-nowrap gap-2 justify-start pb-2 min-w-full">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => {
                    setSelectedCategory(category);
                    setCurrentPage(1);
                  }}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Blog Posts Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-200 hover:-translate-y-1"
              >
                {/* Image */}
                <div className="h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
                      {post.category}
                    </span>
                    <div className="flex items-center text-gray-500 text-sm">
                      <Clock className="h-4 w-4 mr-1" />
                      {post.readTime} min
                    </div>
                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {post.title}
                  </h2>

                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-gray-500 text-sm">
                      <Calendar className="h-4 w-4 mr-1" />
                      {new Date(post.publishedAt).toLocaleDateString()}
                    </div>

                    <Link
                      to={`/blog/${post.slug}`}
                      className="text-blue-600 hover:text-blue-700 font-medium text-sm flex items-center space-x-1 transition-colors duration-200"
                    >
                      <span>Read More</span>
                      <ArrowRight className="h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-12">
              <div className="flex space-x-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 rounded-lg border ${
                    currentPage === 1
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'bg-white text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  Previous
                </button>
                
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`px-4 py-2 rounded-lg ${
                      currentPage === i + 1
                        ? 'bg-blue-600 text-white'
                        : 'bg-white text-gray-700 hover:bg-gray-50 border'
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
                
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className={`px-4 py-2 rounded-lg border ${
                    currentPage === totalPages
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'bg-white text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          )}

          {/* Native Ad */}
          <div className="mt-12">
            <AdBanner size="native" className="mx-auto" />
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-blue-600 rounded-2xl p-8 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Ready to Create Your First Invoice?
            </h2>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Put what you've learned into practice. Create professional invoices in minutes with our free invoice generator.
            </p>
            <Link
              to="/generate-invoice"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-200 inline-flex items-center space-x-2"
            >
              <span>Generate Invoice Now</span>
              <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;